export const environmentVariables = {
  projectId: process.env.REACT_APP_PROJECT_ID || '',
  baseUrl: process.env.REACT_APP_BASE_URL || '',
  kanziKey: process.env.REACT_APP_KANZI_API_KEY || '',
  homePageCmsUrl: process.env.REACT_APP_HOME_PAGE_CMS_URL || 'home',
  forCliniciansPageCmsUrl: process.env.REACT_APP_FOR_CLINICIANS_PAGE_CMS_URL || 'for-clinicians-2607',
  scheduleWorryTimeTemplateId: process.env.REACT_APP_SCHEDULE_WORRY_TIME_TEMPLATE_ID || 28987,
  letterToSelfTemplateId: process.env.REACT_APP_LETTER_TO_SELF_TEMPLATE_ID || 29072,
};
